export default __webpack_public_path__ + "5b7315bd3d0bbbe46275cedaad22e99e.png";